import { PREFECTURE_OPTIONS } from '~/constants/address';

export const convertPrefIdToName = (id: number | string | undefined): string | undefined => {
  if (id == null) return;

  const prefText = PREFECTURE_OPTIONS.find((item) => item.value === +id)?.text;
  return prefText ? String(prefText) : '';
};
